import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const About = () => (
  <section id="about" data-testid="about-section" className="relative py-24 lg:py-32 bg-white text-neutral-900">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-16 items-center">
      <Reveal>
        <div className="relative">
          <div className="absolute -inset-4 bg-[radial-gradient(ellipse_at_center,_rgba(0,85,255,0.07),_transparent_70%)] blur-xl" aria-hidden="true" />
          <div className="relative rounded-3xl w-full aspect-[4/3] bg-[#FAFAFA] border border-slate-200 shadow-[0_24px_64px_rgba(2,6,23,0.08)] flex flex-col items-center justify-center gap-6 p-10">
            <img src="/logo.png" alt="WebStudios logo" loading="lazy" className="w-44 sm:w-56 h-auto object-contain" />
            <p className="font-accent italic text-xl text-slate-500 text-center">Websites built. Websites managed.</p>
          </div>
          <div className="absolute -bottom-6 -right-4 sm:-right-6 bg-white border border-slate-200 rounded-2xl px-6 py-5 shadow-xl">
            <p className="font-display text-lg font-semibold text-slate-900 tracking-tight">One partner.</p>
            <p className="text-sm text-slate-500">Start to finish — and beyond.</p>
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="font-mono2 text-xs tracking-[0.25em] uppercase text-[#0055FF] mb-4">About WebStudios</p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter leading-[1.08] text-slate-900">
          Professional websites, without the technical headache.
        </h2>
        <div className="mt-6 space-y-4 text-base text-neutral-600 leading-relaxed">
          <p>
            WebStudios exists for one simple reason: most businesses need a great website, but very few want to deal with domains, hosting, updates and security to get one.
          </p>
          <p>
            So we handle all of it. We design and build your website, put it live, keep it secure and up to date, and stay on hand whenever you need a change — one straightforward partner for everything your website touches.
          </p>
          <p>
            No jargon. No inflated agency pricing. Just honest, professional web services for businesses that would rather spend their time running their business.
          </p>
          <p className="font-accent italic text-2xl text-slate-900 pt-3">
            — Ismail, founder of WebStudios
          </p>
        </div>
        <a href="#contact" data-testid="about-cta"
          className="mt-8 inline-flex items-center gap-2 bg-neutral-900 hover:bg-neutral-700 text-white font-semibold px-7 py-3.5 rounded-full transition-colors duration-200 group">
          Work with us
          <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
        </a>
      </Reveal>
    </div>
  </section>
);
